var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('Logo'),_c('Menu',{attrs:{"cityCollection":_vm.cityCollection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }